import React, { useState, useEffect } from 'react';
import { default as LastSeen } from './LastSeen';
import { default as HonorProgress } from './HonorProgress';
import { default as PlayerListGroup } from './PlayerListGroup';
import { default as TimeChart } from './TimeChart';
import { default as KillsChart } from './KillsChart';
import { default as ScoreChart } from './ScoreChart';
import { default as MapStats } from './MapStats';
import { default as MatchHistory } from '../MatchHistory';
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Alert,
    Button, Spinner
} from 'reactstrap';
import RestrictedIcon from "../SVG/RestrictedIcon";
import {getTrackerToken} from "../../utils/GetToken";

export default function PlayerInfo({isValid, playerData, mapData, sessionData}) {

    const [sessionOffset, setSessionOffset] = useState(0);
    const [sessionsLoading, setSessionsLoading] = useState(false);
    const [canLoadSessions, setCanLoadSessions] = useState(true);
    
    useEffect(() => {
        if (!isValid) return;
        if (!sessionData || sessionData.length < 10) setCanLoadSessions(false);
        
        async function fetchData() {
            const response = await fetch(`api/session/player?name=${encodeURIComponent(playerData.name)}&offset=${sessionOffset}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${getTrackerToken()}`
                }
            }).then(r => r.json());
            
            if (response.length < 10) setCanLoadSessions(false);
            sessionData.push(...response);
        }
        
        if (sessionOffset !== 0) {
            setSessionsLoading(true);
            fetchData().then(() => setSessionsLoading(false));
        }
    }, [sessionOffset]);
    
    if (!isValid) {
        return (
            <Alert color="danger">
                Whoops, there appears to be no results for that player. We may not have seen this player yet.
            </Alert>
        )
    }

    if (playerData.optedOut) {
        return (
            <Alert color="dark" className="text-center">
                <RestrictedIcon />
                <p>This player profile is <span style={{color: 'red'}}>restricted.</span></p>
            </Alert>
        )
    }

    const mapDataCopy = mapData.slice();
    mapData.sort((a, b) => new Date(b.lastSeen) - new Date(a.lastSeen));

    const handleSessionLoadClick = () => {
        setSessionOffset(sessionOffset + 10);
    };

    return (
        <Card
            color="dark"
            inverse
            style={{
                width: '100%',
                minHeight: '50vh',
                marginBottom: '2rem',
                borderRadius: '10px'
            }}
         >
            <CardHeader className="player-card-header top-rounded">
                {<LastSeen mapData={mapData} sessionData={sessionData} />}
            </CardHeader>
            <CardBody>
                <Card>
                    <CardBody className="mb-3">
                        {<HonorProgress playerData={playerData}/>}
                        {<PlayerListGroup playerData={playerData}/>}
                    </CardBody>
                </Card>
                <Card className="mb-3 mt-3">
                    <CardTitle tag="h5">
                        <div className="d-flex justify-content-center mt-3">
                            Map Breakdown
                        </div>
                    </CardTitle>
                    <CardBody>
                        <div className="stat-table-container">
                            <div className="charts-container">
                                {<TimeChart mapData={mapDataCopy} />}
                                {<KillsChart mapData={mapDataCopy} />}
                                {<ScoreChart mapData={mapDataCopy} />}
                            </div>
                        </div>
                    </CardBody>
                </Card>
                <Card className="mb-3">
                    <CardTitle tag="h5">
                        <div className="d-flex justify-content-center mt-3">
                            Recent Matches
                        </div>
                    </CardTitle>
                    <CardBody>
                        <MatchHistory sessionData={sessionData}/>
                        {sessionData.length >= 10 ?
                            <div className="d-flex justify-content-center mt-3">
                                <Button
                                    color="primary"
                                    onClick={handleSessionLoadClick}
                                    disabled={!canLoadSessions}
                                >
                                    {sessionsLoading ?
                                        <Spinner style={{marginRight: '0.5rem'}} className='center' color="information" size='sm' /> : null
                                    }
                                    {canLoadSessions ? <>Load More Matches</> : <>All Matches Loaded</>}
                                </Button>
                            </div> : null}
                    </CardBody>
                </Card>
                <Card>
                <CardTitle tag="h5">
                        <div className="d-flex justify-content-center mt-3">
                            Map Stats
                        </div>
                    </CardTitle>
                    <CardBody>
                        {<MapStats mapData={mapData} />}
                    </CardBody>
                </Card>
            </CardBody>
      </Card>
    )
}